webpackJsonp([91164660736209],{

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/final.dd08aa1b.png";

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _final = __webpack_require__(199);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 2: Add Feed to Routes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'re going to create a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component to display the tweets, and add it to the routes for our application.'
	    ),
	    _react2.default.createElement(_QuickstartBranch2.default, { branch: 'routing.2' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Create the Feed Component'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Run this CLI command to generate the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate component Feed\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then update the code to look like this:'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n\n        export default createReactClass({\n          displayName: \'Feed\',\n\n          render() {\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className="media-list tweets">\n                  {/* Tweets */}\n                </ul>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class Feed extends React.Component {\n\n          render() {\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className="media-list tweets">\n                  {/* Tweets */}\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        export default Feed;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class Feed extends React.Component {\n\n          render() {\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className="media-list tweets">\n                  {/* Tweets */}\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        export default Feed;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Routes.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'routes.js'
	      ),
	      ' file at the root of your project. It should look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import React from \'react\';\n      import { Route, IndexRoute, Redirect } from \'react-router\';\n\n      import UserIsAuthenticated from \'./src/decorators/UserIsAuthenticated\';\n      import Master from \'./src/components/Master\';\n      import Layout from \'./src/components/Layout\';\n\n      export default (\n        <Route component={UserIsAuthenticated(Master)}>\n          <Route path="/" component={Layout} />\n        </Route>\n      );\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file declares the route hierarchy for your application, which is a set of instructions that determine what gets rendered based on the URL in the browser. If you\'ve used ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'react-router'
	      ),
	      ' before, this file should look familiar.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore makes no modifications to these routes or to the behavior of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'react-router'
	      ),
	      ', so all of React Router\'s documentaion and examples will be directly applicable to your project.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can learn more about this file ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/anatomy/routes/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Add Feed to Routes.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Import the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component into ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'routes.js'
	      ),
	      ' and update the code to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // routes.js\n      ...\n      import Feed from \'./src/components/Feed\';\n\n      export default (\n        <Route component={UserIsAuthenticated(Master)}>\n          <Route path="/" component={Layout}>\n            <IndexRoute component={Feed} />\n          </Route>\n        </Route>\n      )\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here we\'ve added an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'IndexRoute'
	      ),
	      ' inside the root route and configured it to render the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      '. This configuration gives us the flexibility to change what should be displayed on the homepage later, while also declaring that the default view should be the Feed.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Render Route Children in Layout'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you refresh the application right now, you\'ll notice the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component isn\'t being displayed, and that\'s because we haven\'t told the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Layout'
	      ),
	      ' where to render it yet.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To fix this, open the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Layout'
	      ),
	      ' component and find the code in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'render()'
	      ),
	      ' method that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/components/Layout.js\n      <div className="col-md-offset-3 col-md-6">\n        {/* Feed goes here */}\n      </div>\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Modify that code to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/components/Layout.js\n      <div className="col-md-offset-3 col-md-6">\n        {React.cloneElement(this.props.children)}\n      </div>\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When we added the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Feed'
	      ),
	      ' component to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'routes.js'
	      ),
	      ', we listed it as a ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'child'
	      ),
	      ' of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Layout'
	      ),
	      '. The code we just pasted says ',
	      _react2.default.createElement(
	        'em',
	        null,
	        '"clone my children and render them here"'
	      ),
	      ', which means the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Layout'
	      ),
	      ' will be inserted into that ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'div'
	      ),
	      ' tag.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With this change in place, refresh the application and you should now see ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        '"Feed"'
	      ),
	      ' displayed in the middle of the page.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, your application should now look like this.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Feed.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n\n        export default createReactClass({\n          displayName: \'Feed\',\n\n          render() {\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className="media-list tweets">\n                  {/* Tweets */}\n                </ul>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class Feed extends React.Component {\n\n          render() {\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className="media-list tweets">\n                  {/* Tweets */}\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        export default Feed;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class Feed extends React.Component {\n\n          render() {\n            return (\n              <div className="feed">\n                <h2 className="title">\n                  Feed\n                </h2>\n                <ul className="media-list tweets">\n                  {/* Tweets */}\n                </ul>\n              </div>\n            );\n          }\n\n        }\n\n        export default Feed;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'routes.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import { Route, IndexRoute, Redirect } from \'react-router\';\n\n      /**\n       * Wrapping the Master component with this decorator provides an easy way\n       * to redirect the user to a login experience if we don\'t know who they are.\n       */\n      import UserIsAuthenticated from \'./src/decorators/UserIsAuthenticated\';\n\n      /**\n       * Routes are used to declare your view hierarchy\n       * See: https://github.com/ReactTraining/react-router/blob/v3/docs/API.md\n       */\n      import Master from \'./src/components/Master\';\n      import Layout from \'./src/components/Layout\';\n      import Feed from \'./src/components/Feed\';\n\n      export default (\n        <Route component={UserIsAuthenticated(Master)}>\n          <Route path="/" component={Layout}>\n            <IndexRoute component={Feed} />\n          </Route>\n        </Route>\n      );\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/components/Layout.js'
	    ),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        /**\n         * This component is intended to reflect the high level structure of your application,\n         * and render any components that are common across all views, such as the header or\n         * top-level navigation. All other components should be rendered by route handlers.\n         */\n\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n        import Header from \'./Header\';\n\n        export default createReactClass({\n          displayName: \'Layout\',\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-offset-3 col-md-6">\n                      {React.cloneElement(this.props.children)}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        /**\n         * This component is intended to reflect the high level structure of your application,\n         * and render any components that are common across all views, such as the header or\n         * top-level navigation. All other components should be rendered by route handlers.\n         */\n\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import Header from \'./Header\';\n\n        class Layout extends React.Component {\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-offset-3 col-md-6">\n                      {React.cloneElement(this.props.children)}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        export default Layout;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        /**\n         * This component is intended to reflect the high level structure of your application,\n         * and render any components that are common across all views, such as the header or\n         * top-level navigation. All other components should be rendered by route handlers.\n         */\n\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n        import Header from \'./Header\';\n\n        class Layout extends React.Component {\n\n          render() {\n            return (\n              <div>\n                <Header />\n                <div className="container">\n                  <div className="row">\n                    <div className="col-md-offset-3 col-md-6">\n                      {React.cloneElement(this.props.children)}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            );\n          }\n\n        }\n\n        export default Layout;\n        ' })
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to learn about the data structure Lore uses and ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../../data/overview/' },
	        'add some mock data to our application '
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-routing-step-2-js-8fefadf1ee1910e6167e.js